// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gqtR","delete":"styles_delete__22SHh","update":"styles_update__USugd","add":"styles_add__AMDTT"};